import { AppDispatch, RootState } from '@src/store/store'
import { subscriptionsApi } from '@src/api/subscriptions-api'
import { selectUserCurrentAddresses } from '@src/store/ducks/user/selectors'
import { Store } from 'react-notifications-component'
import { isString } from '@src/lib/utils'
import { errors } from '@src/messages/errors'
import { getAccounts } from '@src/store/ducks/user/thunks'
import {
  setIsLoadingChangeSubscription, setIsLoadingSubscriptions, setIsSuccessChangeSubscription, setSubscriptions, setSubscriptionSuccessMessage,
} from './reducer'

export const getSubscriptions = (accountId: number) => async (dispatch: AppDispatch) => {
  try {
    dispatch(setIsLoadingSubscriptions(true))
    const result = await subscriptionsApi.getSubscriptions(accountId)
    dispatch(setSubscriptions(result))
  } catch (err) {
    console.error(err)
  } finally {
    dispatch(setIsLoadingSubscriptions(false))
  }
}

let isCooldown = false
export const addSubscription = (goodId: string) => async (dispatch: AppDispatch, getState: () => RootState) => {
  if (isCooldown) {
    return
  }
  console.log('tap-tap 1')
  try {
    dispatch(setIsLoadingChangeSubscription(true))
    const currentAddresses = selectUserCurrentAddresses(getState())
    if (currentAddresses) {
      const result = await subscriptionsApi.addSubscriptions(currentAddresses.accountId, goodId)
      isCooldown = true
      setTimeout(() => {
        console.log('blocked cooldown is down')
        isCooldown = false
      }, 2000)
      dispatch(setIsSuccessChangeSubscription(true))
      dispatch(setSubscriptionSuccessMessage(result))
      dispatch(getAccounts())
      dispatch(getSubscriptions(currentAddresses.accountId))
    }
  } catch (err: any) {
    console.error(err)
    Store.addNotification({
      title: 'Ошибка!',
      message: isString(err?.response?.data) ? err.response.data : errors.main,
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: {
        duration: 5000,
      },
    })
  } finally {
    dispatch(setIsLoadingChangeSubscription(false))
  }
}

export const closeSubscription = (serviceId: number) => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    dispatch(setIsLoadingChangeSubscription(true))
    const currentAddresses = selectUserCurrentAddresses(getState())
    if (currentAddresses) {
      const result = await subscriptionsApi.closeSubscriptions(serviceId)
      dispatch(setIsSuccessChangeSubscription(true))
      dispatch(setSubscriptionSuccessMessage(result))
      dispatch(getAccounts())
      dispatch(getSubscriptions(currentAddresses.accountId))
    }
  } catch (err: any) {
    console.error(err)
    Store.addNotification({
      title: 'Ошибка!',
      message: isString(err?.response?.data) ? err.response.data : errors.main,
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: {
        duration: 5000,
      },
    })
  } finally {
    dispatch(setIsLoadingChangeSubscription(false))
  }
}
